export const regions = {
  INDIA: { currency: "₹", label: "India (₹)" },
  USA: { currency: "$", label: "USA ($)" },
  UK: { currency: "£", label: "UK (£)" },
  UAE: { currency: "د.إ", label: "UAE (د.إ)" },
  EUROPE: { currency: "€", label: "Europe (€)" }
};
